import Delta from 'quill-delta';
import { txt } from 'libs/i18n';
import { formatMediaTime } from 'libs/format-number';
import { getAllMatchIndices, TIME_STAMP_MARKER_REGEX, } from './text-utils';
const MARKER_LENGTH = 10; // {HH:mm:ss}
const TIMESTAMP_MARKER_REGEX = new RegExp(TIME_STAMP_MARKER_REGEX, 'g');
export default class TimestampMarkers {
    constructor(editorController) {
        this.mediaStartDatetime = null;
        this.editorController = editorController;
    }
    insert() {
        const selection = this.editorController.getSelection();
        if (selection === null)
            return;
        const index = this.editorController.findWordStart(selection.index);
        const wordBegin = this.editorController.textMetadata.getBeginAtIndex(index);
        const timeStampMarker = `{${formatMediaTime(wordBegin, this.mediaStartDatetime)}}`;
        if (this.editorController.getFormat(index - 1).timeStampMarker === true) {
            void this.editorController.onMessage('info', txt('timeStampAlready'));
            return;
        }
        this.editorController.insertTextWithFormat(index, timeStampMarker, { timeStampMarker: true }, 'user');
        this.editorController.textMetadata.addMetadata('displayTimeStamp', index + timeStampMarker.length - 1, true);
        this.editorController.setSelection(index + timeStampMarker.length, 0);
    }
    updateMediaStartDatetime(mediaStartDatetime) {
        if (this.mediaStartDatetime === mediaStartDatetime) {
            return;
        }
        this.mediaStartDatetime = mediaStartDatetime;
        this.update();
    }
    update() {
        const text = this.editorController.getText();
        const markerIndices = getAllMatchIndices(text, TIMESTAMP_MARKER_REGEX);
        if (markerIndices.length === 0) {
            return;
        }
        this.editorController.execTextChange({ updateMetadata: false, runAligner: false, requestSave: false }, () => {
            let delta = new Delta();
            let currentPosition = 0;
            markerIndices.forEach((markerStart) => {
                const time = Math.round(this.editorController.textMetadata.getBeginAtIndex(markerStart + MARKER_LENGTH));
                const newMarker = `{${formatMediaTime(time, this.mediaStartDatetime)}}`;
                if (text.slice(markerStart, markerStart + MARKER_LENGTH) === newMarker) {
                    return;
                }
                delta = delta
                    .retain(markerStart - currentPosition)
                    .delete(MARKER_LENGTH)
                    .insert(newMarker, { timeStampMarker: true });
                currentPosition = markerStart + MARKER_LENGTH;
            });
            this.editorController.updateContents(delta, 'api');
        });
    }
}
